import { useEffect, useState } from "react";
import { get_canales_notificaciones } from "../../../actions";
import { SelectUi } from "../../ui";

export const CanalesNotificacionSelect = ({ ...props }) => {
  const [opciones, setOpciones] = useState([]);

  useEffect(() => {
    const OnLoad = async () => {
      const datos = await get_canales_notificaciones();
      setOpciones(datos);
    };
    OnLoad();
  }, []);

  return <SelectUi data={opciones} {...props} />;
};
